/* Public Judge.me feed. No private credentials, review writes or customer email calls. */
(() => {
  'use strict';
  // Existing Loox purchases confirmed by the merchant on 14 September 2026.
  // Exact imported review IDs only; new reviews still require Judge.me verification.
  // BEGIN IMPORTED VERIFIED BUYERS (generated by clearup-build/restore-loox-verification.py)
  const importedVerifiedBuyers = new Set([
    "00cd88d8-b032-4813-b8b7-93dcaebff907",
    "00dbf9e7-8177-4659-8948-d2c5b3deea36",
    "011e7d9c-ba55-4783-909a-1887bfceb3ae",
    "01d1a7dd-0c11-4933-b2eb-3feaae1e8d12",
    "02268f03-a02f-4ffb-858f-22aeb4979622",
    "0280c925-4161-4e96-90a2-eff5a3ed9093",
    "02889b34-3195-42e8-8b5e-004a61ae31f2",
    "02de9abf-b533-4695-a426-c0bc5c019605",
    "02ffb0d4-f76c-42f1-be89-a457cab7e784",
    "03bd2204-94e9-41aa-9906-ee6480f48a1c",
    "06b4e689-8c84-4b37-a350-c4201e8b7e34",
    "079b4f0e-9626-4832-b124-f8df8b8949c0",
    "08a0514f-87d6-4c0e-92b2-e5e8947abad7",
    "0c85eefc-5be8-4d28-bd04-4d316b5e50d2",
    "0cba1bdf-b5fe-4907-abf7-ac3c9660dd3a",
    "0d220442-e723-41c7-8fde-deb1f21d5348",
    "0dc34ae9-9a84-4a5d-81e0-f437b1425c1c",
    "10bea1ba-99a3-5c7a-98de-243aba465842",
    "111b602a-90f7-44f1-b3e8-26b09b5ebee6",
    "11c82707-393e-4923-8066-e19b535a7d74",
    "1204ed1b-24ef-4155-a641-9c8387781f1e",
    "13f08518-ad22-43a4-af26-bbdbd61e4509",
    "1462f755-1b77-4250-bbe9-a2a2e2b7d674",
    "14ba275f-7a47-4c95-96ba-159c5381ee5c",
    "162f9dcd-163a-43c8-9415-16fcd271f9c9",
    "172e1aa3-e374-433a-9e65-01b73edc5655",
    "17ca0e41-d955-44f3-9aff-5a55c9c991cf",
    "1aa8ae20-d26c-579c-a546-9f3a6c6c8373",
    "1aeab28b-4041-498e-a5ad-16c66948db62",
    "1b26ad9f-7b11-511b-a21e-e77b43528bde",
    "1b467086-ea23-42da-8a26-d608e5bc3935",
    "1b519ebe-e1c9-4897-9599-79f6c83e3e9a",
    "1bec52cc-0ce2-47b9-a15d-2a16edde2216",
    "1e309cc6-d1ff-498f-a798-d1d7d75a8a97",
    "224f8288-9e99-4ced-98a6-c184e90f7f3c",
    "231100cf-5923-4d0b-8e0f-d4b30c2d40f5",
    "23b15c77-0921-4286-ba19-9e2c2eea74d7",
    "24ac6cd6-8967-4409-8f71-68f5fdcd416a",
    "259465cc-1177-4bc3-b239-6562292a6f83",
    "2741b72f-abd6-4973-8edc-06075b3bde91",
    "281a63e5-0fc8-431c-a1ae-0920b803583e",
    "288498af-76de-4c59-9c92-7ba88338b110",
    "28c7dff5-7cc8-4cb7-99cb-c5b1be2b783d",
    "28e2c67b-0f95-41c4-8672-5237dc75f422",
    "2a4fcc29-c7a8-522c-a7e8-87335ca5e565",
    "2a84484d-cd89-4224-8ad9-6c459ff709ee",
    "2aa258ae-8efe-49e2-8647-8bb0e0287d7f",
    "2aaca772-74c3-4871-b671-a3a7b11ef5ab",
    "2c063957-324f-44f8-be18-147f80bb2f48",
    "2c237c82-a515-4554-96d2-8611801e726a",
    "2c279bf3-af4e-4a40-9925-d9745962fdc2",
    "2fa5a4d6-3da2-49dd-aed4-72b79939a249",
    "30870a86-441a-46b0-bed3-87b867d9171e",
    "30ea7aa3-7137-4f2a-816a-e85dd07782b6",
    "32022326-30b2-4130-a34a-1448ce63c3a3",
    "32f46946-41d0-4f0c-a51b-5d4e9805ca32",
    "32fac428-620a-4d2d-9a00-a4a105ec654f",
    "3317ba16-2f9e-4453-8a7a-8a393791ffe7",
    "3401de13-55b5-4956-9845-7e44b8bcb262",
    "34821c91-59a8-4ffa-9911-58ea561c762e",
    "3691c4ee-35bb-4207-8fdf-0f4a3fa9d2cd",
    "36b5de3f-1d29-42b3-abfd-daa7c8a8687f",
    "36e66011-2020-4adc-9b69-021d167fb9a5",
    "38143b7c-90f1-4da4-acc1-187b5c592691",
    "384288b3-be01-4105-9643-6f2349894aeb",
    "38f9e1e5-bcf8-4262-b4a4-758c359cc96e",
    "391ab5c4-2f63-4dbc-95e6-4b96173d4111",
    "3a1077dc-c90c-4321-aeb0-333255bfcbf4",
    "3aa0a1cc-4e71-4ca2-89cb-de0531a3d9ac",
    "3af1fc98-89e0-437a-9292-15862c5c480d",
    "3c22b1a5-0ea0-4dff-a4a7-08898374732b",
    "3de7d9f6-6a90-4a07-a38e-f04501c8c0df",
    "402ba0d1-8dd4-4fc2-aabb-8c23a96a421d",
    "408a1e1d-88ed-5f4a-b788-b20023e5bc16",
    "421acdb0-8f9f-5d0c-8965-3f9b49958101",
    "4222489d-7856-4287-975c-2519fa1956ff",
    "429fe06e-cce7-4a55-90c9-799155b4f9f1",
    "438f123e-bce9-406c-bfdc-774aa7fd0c0e",
    "440573b2-789c-4b6f-8713-d60a51353591",
    "4461c627-3c8b-4083-bff5-f559599caabd",
    "47d29770-b518-48b7-b0de-0f2747b93206",
    "47d8cc64-2560-440a-8794-58aa9ab67104",
    "481fe8fb-3a9a-4cf8-8fe1-6e44aa4334dd",
    "486831db-47f7-54f6-ab93-c128a29b3b36",
    "4b2f65be-fdfd-4e7e-9786-6a76715aa95e",
    "4b4a0a93-e566-57f6-a46a-606eae5d96e9",
    "4b823496-a745-42de-93c6-3fadc31612a7",
    "4c03cfb6-a0f7-505e-b69f-de88f331b8c9",
    "4e9dd279-65b9-4b54-9e9d-f61ec06dcd3b",
    "4ee46b92-2bca-4ac6-b486-9a0ac717967b",
    "5113eff8-f346-4c12-a7f6-33b00170e1ac",
    "515af68f-113e-5ae2-9dff-512e1e35e8b6",
    "550a34e5-efde-4497-8681-fbd2c8b382c9",
    "55768540-4056-4716-b8a4-5b009a1654fd",
    "56fb8474-b1c7-4dcd-9a7e-67950b886343",
    "58d82c0f-4c8e-4fc3-9022-abb57eaf329a",
    "5901d412-6afd-4d37-a10a-d0b1a4eefee9",
    "592de524-738c-4b79-abe7-7d478322cfe6",
    "5940fde5-44e0-585f-a0e1-8810a1053c95",
    "5aea4594-08c1-49b0-be8f-719030143bd0",
    "5b934031-462e-4d7e-9250-47125ec0e822",
    "5bd0ee02-5048-4105-b54a-2e2fea0fd004",
    "5c7d502d-1cd4-4cdc-aacf-f959f4090429",
    "5d977ff8-e4c2-45e5-89a4-ceb43ab2665a",
    "5e98e080-b1de-42d3-be01-78148378b47b",
    "5f413164-ad58-4221-b3e2-c67a25079278",
    "5fc2c884-7ac0-4299-9929-d6cbec284afa",
    "5fe5e5f9-8f58-4ad4-8e58-60b782f40a95",
    "602f03de-6655-426c-bb14-5edb0529a8c8",
    "6036b021-9390-4279-928b-8968f44a9535",
    "61bb5e97-0377-5830-be1e-af2295eb7b31",
    "6208ccff-46de-4159-a73a-b44112bec436",
    "63ad2d2b-fea8-50f8-93b9-c47061ead9b5",
    "64fee716-9a9d-5d3f-9d07-88be5213ada2",
    "6549c719-db92-456b-87a3-777917878f2a",
    "67167c39-0b74-45a8-b9c2-21f04d26ecc1",
    "69f0c157-5933-445d-a94a-96eb1bc3356a",
    "6c103d9e-bda4-47c2-9a89-db7ba667d5d3",
    "6d52a6b0-d795-4f37-8fd7-1274d2d22468",
    "6da42076-36af-59ff-afe0-3e79c281c007",
    "7049a61b-0aa5-54b8-a341-986910b9f66e",
    "712276f4-3e4a-4ead-952c-5c714e2205ca",
    "71da9fb4-bc5b-44d8-92fe-922ad4d8dfe5",
    "7262a352-4002-4db1-9075-b6d56b083b2b",
    "72a72bcd-bfa6-491a-b5e7-b55657cff235",
    "73104475-cf97-5ccd-8b87-f1785b54ef49",
    "73a708ff-7b81-5a11-9428-16fefb3f230e",
    "7454b716-9751-46fa-86ba-2024fc27285a",
    "75206d5a-b574-41bb-8d93-5650b0c68ce7",
    "75fc1adb-facf-4ece-8878-d5c0eacc127c",
    "761cf6eb-d7f4-4fe0-8f2d-8b8475ec78a8",
    "76eb5798-5700-49a2-8db0-239dd1ccd7b5",
    "782457aa-1ea2-4d3c-affa-b468aaf7f89f",
    "78b4bf7b-423c-42d4-99c6-7eb4d1c00bef",
    "79c16d43-55b0-4dfb-9c68-3a2ac66abb55",
    "7a57c6e0-d316-4d7e-a810-0c7b6161366a",
    "7ac73531-58b5-40d4-8509-d8d8e362c060",
    "7b0875f8-9459-4292-96a7-bf4258ff1bc5",
    "7b7bd1c9-5707-4c26-8131-e23424e7a014",
    "7bdd57f5-5e8c-4048-b921-f258ede8494c",
    "7cf9a0ed-4e2b-452c-89eb-f172131c5806",
    "7e492491-53b9-4c11-a690-85100bfe6cbf",
    "7ff3897e-fe52-51ad-9e9d-c724c7c97499",
    "8011cb7e-672e-4f53-a4a5-747e32ee69e3",
    "80736026-ee73-4ce6-ac0a-ffb923d1ede4",
    "80d5d6d3-847c-4d31-956d-28d88fc10ccb",
    "8123248a-2ce6-4469-a292-7549c5ebaad5",
    "81826e4b-c8c6-443a-8926-cf9d9ef809fe",
    "822db48d-d283-42dc-a8c5-ca349823c387",
    "830921d4-d31b-577b-9025-f71607e59fcd",
    "83ecf8bb-cf9d-4665-a387-37a4d99e97cd",
    "86765035-1c96-4d63-b1ff-f34c054ec8b4",
    "86ae440a-0d56-4e80-93a1-4a2cf1447e20",
    "871a3f0f-2c98-4245-84d7-f0ed783f0ad5",
    "87e2f9b2-09e1-44e0-8e45-3e53afb784c8",
    "89f97423-9ec4-4541-a9d6-27758b5ee8f4",
    "8a3a60b4-ce33-4e38-a739-40765d4ac3a0",
    "8a634648-95b1-4197-98cb-b92e3e98e503",
    "8ab75ef6-5c5b-401a-a038-860e89719b82",
    "8ab761ed-3fce-50e9-8f99-8e94a6daa87b",
    "8c74defb-2efb-4a8d-b4e0-410f48dc2a5c",
    "8e8e3d0c-febe-4c1b-9464-78361f60d2eb",
    "8ea91d23-92d8-4ece-97ba-74245c590501",
    "9191ff68-69a5-471b-adaa-340e39f347b5",
    "92f91ddf-3647-4da4-8295-8ccfd9b94924",
    "930b6fec-f0bc-5cea-a08f-a1dd0d3a7840",
    "943c9b1b-08de-41de-ac55-1bd28e9e99cb",
    "946e7966-2a47-491a-9057-4c908a0830e3",
    "948c5938-a307-44d0-9eb6-b776b7c37448",
    "95255a42-799c-45f9-90a7-b8fb3b4993a6",
    "9607846a-b05e-4b4d-8972-c56f25ac50ee",
    "9749bd6b-575b-45c2-8727-5153d4e739af",
    "9783c184-c0c1-4a0c-b521-5f789a7cc137",
    "99dbf2a5-f4fc-4b68-888e-bbd2aba44cef",
    "9a54d3cc-d1cd-470a-bcd1-8b14b166df18",
    "9a92c709-aef1-4af6-97d0-1aced48900d7",
    "9ae4acaf-4c88-4471-965c-77cff8d0d936",
    "9c86a652-6942-4680-a683-46ba0612ceb7",
    "9cf2c569-32b5-4b06-a015-aa03adc8379e",
    "9d2ab476-1ce9-4ba4-b44f-3aec1d8587fa",
    "9eb50f2c-6121-4ee2-919c-899290edc5ec",
    "a0b95f20-0562-4ac5-a75b-4f85edb59ce3",
    "a1bf0f7f-3be4-48bb-9475-7e7d1224b2d0",
    "a331aea6-e1e3-4a0f-933c-70f6b6f48ce0",
    "a3fb563d-dde5-44cf-91a2-e1bf1111d347",
    "a45a574d-6bf4-4a17-9920-377a27b9c407",
    "a4fe12e9-73c4-4fb0-a806-acfbfa8c96ad",
    "a52f265c-dd4e-41d3-af9a-79bdcee89776",
    "a58e1a28-545b-4c51-994b-a7838ba2f450",
    "a6512546-dd02-4a8b-8c13-2c5e65589ab5",
    "a6d32572-9b15-4c44-8b6c-c327ac3cdc4f",
    "a7686dd6-1ebd-4d23-a340-85e74c1dcf19",
    "a79f5db9-84d9-4859-a866-f0f451ea0abd",
    "a91391d9-9f60-4b43-b1a2-6cdb6d788371",
    "ab61847f-5743-4eed-bc6e-936924342d4c",
    "abb7950e-869e-4a34-86cd-8ef3897d4e05",
    "abfc2ef2-60db-5759-baa9-349e12c6bf34",
    "ac50a462-74b8-44f8-8cd8-ac4364f79d03",
    "ad239dec-8877-43cc-896b-40ffaac0d1fe",
    "af4a31da-f69b-486c-b1f4-afe9c72afff1",
    "afbf8da0-a8c1-417a-9b13-a8d804bb0b52",
    "b289ba81-2c51-45cc-a36b-0034f43a64af",
    "b34f9a81-cf81-43b7-b064-3ecd93b19825",
    "b39f54b2-991f-4055-98c1-5c1e390ca83e",
    "b41c74f6-2361-4798-b776-1b1d71aec9b2",
    "b66e1af5-a536-4fae-bd43-6a1063d84f2d",
    "b6f9eddf-7114-4f35-8628-238c713d02f1",
    "b833023f-6886-4a5f-afab-a52db4bc8766",
    "b996be56-9d9b-42d1-bc39-5f134286f835",
    "bb2dc2b2-5ba2-4f2b-a9f6-282739ab9c06",
    "bb647916-6d74-4a1a-aaa1-a6a82d1bf9ee",
    "bd2ea40a-5719-4d1a-9bbc-3efb94b0a86d",
    "be0ef7f2-2562-4d4c-89d3-dcb3df375a3d",
    "be93de98-7740-4798-aec8-3332f68018a0",
    "bebdd659-f70b-4c33-a98c-e7ac4c31afd5",
    "c31c9593-6096-4d85-b575-af2733b51e09",
    "c49fcef2-40d8-4934-adfe-f209f74bc102",
    "c61621ad-44a5-4680-8636-5abf92d2d1fa",
    "c7299468-9ebd-413f-b352-9258dfd47fc9",
    "c98390a2-58a4-40cd-8f3a-cb62f4e515f3",
    "c9a391b5-8493-4243-903b-ca16870e9b77",
    "cab02d44-552e-4954-8365-32430520b2ee",
    "cbbe1d90-9b8f-4615-8ebf-7afbc30a580d",
    "cd92e396-323d-41e9-abaf-b221af12c95a",
    "cda542b0-8fe9-4efc-9d24-b6ffe51c56fb",
    "cdf5df9d-20d7-468c-8544-0575f364c5fb",
    "d0540ed2-5a69-46c7-96f9-1a3bceddda40",
    "d0a2591c-38f8-4aee-a2c9-7dea6b2f435a",
    "d1540b60-59b7-4c99-b0ad-423222068087",
    "d1c6a9b9-01d2-4c30-8743-0d2fccdd9361",
    "d227e32e-669d-4877-a0dc-a3a7dac4fb76",
    "d2556cc6-b2bb-4d8f-92f6-1d9b7d49acba",
    "d4ce893f-48b9-42e0-8345-c03ece1ae32c",
    "d5fc399a-d00a-4043-98b4-1c341670e453",
    "d7db4ad8-26b6-440d-b7f9-f51e850ea0c0",
    "d951fceb-40fc-40e3-a1b7-c037987b4a55",
    "db1a1d32-7c13-4a43-af45-506eb3c6bc96",
    "db296f36-fa85-4904-b540-438013e24c1c",
    "dc6526dd-0bb9-4e11-9e12-2616a4f470ab",
    "dcdb5ed7-7c78-49c9-898f-8693b605a8cf",
    "dd532b8e-aa6d-4ad2-97b6-d614188c9a45",
    "dd8e4216-4c11-42ec-8f2d-eebbcbba46f7",
    "dd9df850-cab8-444c-875e-d4e9645e7b04",
    "deb95892-c018-4753-8c4c-193e26774c49",
    "defd6b20-24d7-43c5-afcd-4299a988b31b",
    "df490966-2813-46dd-ba73-643351552c81",
    "df74e6fd-ff8e-4c79-a243-4638e5d287fd",
    "df936c65-dafd-4ca1-9f42-4a31e37c2e1e",
    "e1544c37-779b-4f15-bd83-897a02977a12",
    "e1d88e99-6462-5d49-a806-54c2514b3554",
    "e249bb10-9263-4a76-ac46-8b38d4911338",
    "e277bfbc-10e8-494e-9789-5fd5f1cc13ea",
    "e313a7c1-ec7d-45a5-be65-dcee668cdfc0",
    "e319495a-7c70-4f47-acad-8f781c35cab8",
    "e358d448-0781-4a17-845b-c0617029424f",
    "e3ef7185-2ec7-49c3-8f27-4065cbde1740",
    "e4fc7eb3-52b1-46ba-a0f8-ddb7b8e84cd1",
    "e58cd85b-5af8-5f26-97d3-8323282c9118",
    "e59d7284-66ca-4a84-89c5-b5fbb33e038e",
    "e66542ca-7fa2-45bc-a449-c33bb8808daf",
    "e866c71c-ffc5-4814-9194-ba416ee49427",
    "e88b7e39-dca3-4141-9da4-d9e4baff2bb1",
    "e910daf7-b6ea-4bb1-b95c-2d5d78840bc3",
    "eb2a08f0-703e-44c4-8b82-7e0cfb6d69cb",
    "ebd3e4eb-185f-48a9-9b0d-9a5b1070bf91",
    "ecb6d63b-6be8-4f02-9016-85c8e90b713b",
    "ed3fe894-cb70-4125-8a17-42637c7ce202",
    "edd76982-dac2-45ac-9d7c-345cc9bd94f7",
    "edf4853e-64bc-4ae7-9e54-57f6b430636a",
    "ee2cb667-ccaa-41c9-aa39-c554144cdeeb",
    "ef88421b-0ed1-4749-8836-d62a5039f4cb",
    "efb932b0-2b49-4b8e-91c9-32d4c0261785",
    "f015945f-a47f-5a82-b48a-e01cafb3f68c",
    "f038760e-ccb6-56af-9750-4ffc60990c77",
    "f03dc2b3-a70e-4fc1-99bf-d9ec4df5fdf7",
    "f2490047-4b2c-427c-a3e0-aa1adf9132f0",
    "f43ecd7a-1d64-4b05-acc5-51e0917223a8",
    "f4482fb7-bc70-47c6-8a7d-f423883d07c5",
    "f9380478-061b-454c-bafe-9da84ea513be",
    "f9c63944-0cee-4bb2-96fe-ed538826a004",
    "fa2b80d3-b8d2-4444-8ed1-e04777069e92",
    "fac53b82-709e-4c28-934e-dd4e300cd208",
    "fb605f3e-cacb-48ee-bdba-e09793c7b458",
    "fc94176c-64f7-422c-bfe2-9d95ae0f82ae",
    "fcba07a2-32e8-48be-99d3-d553691ce735",
    "fdab2cc3-ea2e-4bce-b7d4-6fe1fe733b09",
    "fe134dc1-6609-4b2f-b64a-c77ff8401b74",
    "fffad28a-3bcf-42a6-be90-6c91567060be",
  ]);
  // END IMPORTED VERIFIED BUYERS
  const aliases = { 'microdarts-for-acne-iibscart20ll': 'microdarts-for-acne', 'invisipatch-iibscart30ll': 'invisipatch' };
  const el = (tag, className, text) => {
    const node = document.createElement(tag); if (className) node.className = className;
    if (text != null) node.textContent = String(text); return node;
  };
  function productHandle(review) {
    try {
      const path = new URL(review.product_url, location.origin).pathname;
      const handle = path.match(/^\/products\/([^/]+)\/?$/)?.[1] || '';
      return aliases[handle] || handle;
    } catch { return ''; }
  }
  function mediaUrl(value) {
    if (typeof value !== 'string') return '';
    try { const url = new URL(value); return url.protocol === 'https:' ? url.href : ''; } catch { return ''; }
  }
  function pictureUrl(picture) {
    if (!picture || picture.hidden) return '';
    return mediaUrl(typeof picture === 'string' ? picture : (picture.huge || picture.original || picture.url));
  }
  async function pool(jobs, concurrency = 3) {
    let index = 0; const results = new Array(jobs.length);
    await Promise.all(Array.from({ length: Math.min(concurrency, jobs.length) }, async () => {
      while (index < jobs.length) { const current = index++; results[current] = await jobs[current](); }
    }));
    return results;
  }
  const reviewCache = new Map();
  const reviewCacheAge = 5 * 60 * 1000;
  // Cache only public fields used by the cards, never an entire API response.
  const cachedReviewFields = ['uuid', 'rating', 'created_at', 'title', 'body', 'reviewer_name',
    'is_anonymous_reviewer', 'verified_buyer', 'product_url', 'product_title', 'product_in_store', 'reply_content'];
  // Select-only comboboxes keep the native select as the review filter's value
  // source, while avoiding the platform-specific iOS picker and field styling.
  class CuReviewFilter extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.select = this.querySelector('select'); this.label = this.querySelector('label');
      if (!this.select || !this.label) return;
      this.events = new AbortController(); const opts = { signal: this.events.signal };
      this.control = el('div', 'cu-review-select__control');
      this.button = el('button', 'cu-review-select__button'); this.button.type = 'button';
      this.button.id = `${this.select.id}-button`; this.button.setAttribute('role', 'combobox');
      this.button.setAttribute('aria-haspopup', 'listbox'); this.button.setAttribute('aria-expanded', 'false');
      this.valueLabel = el('span'); this.valueLabel.id = `${this.select.id}-value`;
      this.button.setAttribute('aria-labelledby', `${this.label.id} ${this.valueLabel.id}`);
      this.button.append(this.valueLabel);
      this.button.insertAdjacentHTML('beforeend', '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true" focusable="false"><path d="m4 6 4 4 4-4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>');
      this.list = el('ul', 'cu-review-select__options'); this.list.id = `${this.select.id}-options`;
      this.list.setAttribute('role', 'listbox'); this.list.setAttribute('aria-labelledby', this.label.id); this.list.hidden = true;
      this.button.setAttribute('aria-controls', this.list.id);
      this.items = [...this.select.options].map((option, index) => {
        const item = el('li', 'cu-review-select__option', option.text);
        item.id = `${this.select.id}-option-${index}`; item.setAttribute('role', 'option');
        item.dataset.reviewOptionValue = option.value;
        item.addEventListener('click', () => { this.active = index; this.commit(); this.button.focus({ preventScroll: true }); }, opts);
        return item;
      });
      this.list.append(...this.items); this.control.append(this.button, this.list); this.append(this.control);
      this.select.hidden = true; this.label.htmlFor = this.button.id; this.active = this.select.selectedIndex; this.sync();
      this.button.addEventListener('click', () => this.list.hidden ? this.open() : this.close(), opts);
      this.button.addEventListener('keydown', event => this.onKey(event), opts);
      this.select.addEventListener('change', () => this.close(), opts);
      // Prevent focus transfer, without cancelling touch gestures used to scroll the menu.
      this.list.addEventListener('mousedown', event => event.preventDefault(), opts);
      document.addEventListener('pointerdown', event => { if (!this.list.hidden && !this.contains(event.target)) this.close(); }, opts);
      this.addEventListener('focusout', event => { if (!this.contains(event.relatedTarget)) this.close(); }, opts);
      window.addEventListener('resize', () => { if (!this.list.hidden) this.positionList(); }, opts);
      document.addEventListener('scroll', event => { if (!this.list.hidden && event.target === document) this.close(); }, { ...opts, passive: true });
    }
    sync() {
      if (!this.button) return;
      this.valueLabel.textContent = this.select.selectedOptions[0]?.text || '';
      this.button.disabled = this.select.disabled;
      if (this.list.hidden) this.active = this.select.selectedIndex;
      this.items.forEach((item, index) => {
        item.setAttribute('aria-selected', String(index === this.active));
        item.toggleAttribute('data-selected', index === this.select.selectedIndex);
      });
    }
    positionList() {
      const rect = this.button.getBoundingClientRect(), viewport = window.visualViewport;
      const top = viewport?.offsetTop || 0, bottom = top + (viewport?.height || innerHeight);
      let floor = bottom - 12, ceiling = top + 12;
      const dock = document.querySelector('[data-cu-buybar]:not([hidden])');
      if (dock) { const r = dock.getBoundingClientRect(); if (r.height && r.top > rect.bottom) floor = Math.min(floor, r.top - 8); }
      for (const selector of ['.cu-header', '.cu-astra__index']) {
        const node = document.querySelector(selector); if (!node) continue;
        const r = node.getBoundingClientRect(); if (r.bottom > top && r.bottom < rect.top) ceiling = Math.max(ceiling, r.bottom + 8);
      }
      const below = floor - rect.bottom - 8, above = rect.top - ceiling - 8;
      const upwards = below < this.items.length * 44 + 14 && above > below;
      this.list.toggleAttribute('data-above', upwards);
      this.list.style.setProperty('--cu-filter-menu-height', `${Math.max(44, Math.min(300, upwards ? above : below))}px`);
    }
    open() {
      this.closest('cu-reviews')?.querySelectorAll('cu-review-filter').forEach(filter => { if (filter !== this) filter.close(); });
      this.active = this.select.selectedIndex; this.list.hidden = false;
      this.button.focus({ preventScroll: true });
      this.button.setAttribute('aria-expanded', 'true'); this.positionList(); this.highlight(this.active);
    }
    highlight(index) {
      this.active = Math.max(0, Math.min(this.items.length - 1, index)); this.sync();
      const item = this.items[this.active]; this.button.setAttribute('aria-activedescendant', item.id);
      // Scroll only the menu, without jumping the product page underneath it.
      const row = item.getBoundingClientRect(), menu = this.list.getBoundingClientRect();
      if (row.top < menu.top + 6) this.list.scrollTop -= menu.top + 6 - row.top;
      else if (row.bottom > menu.bottom - 6) this.list.scrollTop += row.bottom - menu.bottom + 6;
    }
    close() {
      if (!this.list) return;
      this.list.hidden = true; this.button.setAttribute('aria-expanded', 'false');
      this.button.removeAttribute('aria-activedescendant'); this.search = ''; this.typedAt = 0; this.sync();
    }
    commit() {
      const value = this.select.options[this.active]?.value;
      const changed = value != null && value !== this.select.value;
      if (changed) this.select.value = value;
      this.close();
      if (changed) this.select.dispatchEvent(new Event('change', { bubbles: true }));
    }
    onKey(event) {
      if (event.ctrlKey || event.metaKey) return;
      const key = event.key, wasOpen = !this.list.hidden;
      if (key === 'Tab') { if (wasOpen) this.commit(); return; }
      if (key === 'Escape') { if (wasOpen) { event.preventDefault(); event.stopPropagation(); this.close(); } return; }
      if (['Enter', ' ', 'ArrowDown', 'ArrowUp', 'Home', 'End', 'PageUp', 'PageDown'].includes(key)) {
        event.preventDefault();
        if ((key === 'Enter' || key === ' ' || (key === 'ArrowUp' && event.altKey)) && wasOpen) return this.commit();
        if (!wasOpen) this.open();
        if (key === 'Home' || key === 'PageUp') this.highlight(0);
        else if (key === 'End' || key === 'PageDown') this.highlight(this.items.length - 1);
        else if (key === 'ArrowDown' && wasOpen && !event.altKey) this.highlight(this.active + 1);
        else if (key === 'ArrowUp' && !event.altKey) this.highlight(wasOpen ? this.active - 1 : 0);
        return;
      }
      if (key.length === 1 && !event.altKey) {
        event.preventDefault(); if (!wasOpen) this.open();
        const now = Date.now(); this.search = now - (this.typedAt || 0) < 600 ? (this.search || '') + key.toLowerCase() : key.toLowerCase(); this.typedAt = now;
        const repeated = [...this.search].every(char => char === this.search[0]), term = repeated ? this.search[0] : this.search;
        for (let offset = repeated ? 1 : 0; offset < this.items.length + (repeated ? 1 : 0); offset++) {
          const index = (this.active + offset) % this.items.length;
          if (this.items[index].textContent.toLowerCase().startsWith(term)) { this.highlight(index); break; }
        }
      }
    }
    disconnectedCallback() {
      this.events?.abort(); this.control?.remove();
      if (this.select) this.select.hidden = false;
      if (this.label) this.label.htmlFor = this.select.id;
      this.events = null;
    }
  }
  if (!customElements.get('cu-review-filter')) customElements.define('cu-review-filter', CuReviewFilter);
  class CuReviews extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();
      this.fixedProduct = this.dataset.productHandle || '';
      this.reviewHandles = new Set((this.dataset.reviewHandles || this.fixedProduct).split(/\s+/).filter(Boolean));
      this.isBundle = this.dataset.reviewScope === 'bundle';
      this.pageSize = this.fixedProduct ? 6 : 12;
      this.productButtons = [...this.querySelectorAll('[data-review-product]')];
      this.picker = this.querySelector('[data-product-picker]');
      this.pickerControls = this.querySelector('[data-picker-controls]');
      this.pickerPrev = this.querySelector('[data-picker-prev]');
      this.pickerNext = this.querySelector('[data-picker-next]');
      this.product = 'all';
      this.rating = this.querySelector('[data-review-rating]');
      this.sort = this.querySelector('[data-review-sort]');
      this.grid = this.querySelector('[data-review-grid]');
      this.status = this.querySelector('[data-review-status]');
      this.more = this.querySelector('[data-review-more]');
      this.retry = this.querySelector('[data-review-retry]');
      this.videoHost = this.querySelector('[data-review-videos]');
      this.videoTemplate = this.videoHost?.firstElementChild.cloneNode(true);
      this.rows = []; this.complete = false; this.limit = this.pageSize;
      this.readUrl(); this.renderVideos();
      for (const button of this.productButtons) button.addEventListener('click', () => {
        if (this.product === button.value) return;
        this.product = button.value; this.limit = this.pageSize;
        this.syncProductPicker(); this.writeUrl(); this.renderVideos(); this.render();
      }, { signal: this.events.signal });
      this.picker?.addEventListener('scroll', () => this.updatePickerControls(), { passive: true, signal: this.events.signal });
      for (const [button, direction] of [[this.pickerPrev, -1], [this.pickerNext, 1]]) button?.addEventListener('click', () => {
        this.picker.scrollBy({ left: direction * this.picker.clientWidth * .8, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }, { signal: this.events.signal });
      this.pickerObserver = new ResizeObserver(() => this.updatePickerControls());
      if (this.picker) this.pickerObserver.observe(this.picker);
      for (const control of [this.rating, this.sort]) control.addEventListener('change', () => {
        this.limit = this.pageSize; this.writeUrl();
        this.render();
      }, { signal: this.events.signal });
      this.more.addEventListener('click', () => {
        const firstNew = this.limit; this.limit += this.pageSize; this.render();
        const card = this.grid.children[firstNew]; card?.focus({ preventScroll: true });
      }, { signal: this.events.signal });
      this.retry.addEventListener('click', () => this.load(true), { signal: this.events.signal });
      this.querySelector('[data-review-clear]').addEventListener('click', () => this.reset(), { signal: this.events.signal });
      this.querySelector('[data-review-reset]')?.addEventListener('click', () => this.reset(), { signal: this.events.signal });
      window.addEventListener('popstate', () => { this.readUrl(); this.limit = this.pageSize; this.renderVideos(); this.render(); }, { signal: this.events.signal });
      this.load();
    }
    readUrl() {
      const params = new URL(location.href).searchParams;
      const assign = (control, key, fallback) => {
        const value = params.get(key); control.value = [...control.options].some(o => o.value === value) ? value : fallback;
      };
      const product = params.get('review_product');
      this.product = this.fixedProduct || (this.productButtons.some(button => button.value === product) ? product : 'all');
      this.syncProductPicker();
      assign(this.rating, 'review_rating', 'all'); assign(this.sort, 'review_sort', 'pictures');
      this.querySelectorAll('cu-review-filter').forEach(filter => filter.sync());
    }
    syncProductPicker() {
      if (!this.picker) return;
      for (const button of this.productButtons) {
        const selected = button.value === this.product;
        button.setAttribute('aria-pressed', String(selected));
        if (selected) {
          const card = button.getBoundingClientRect(), rail = this.picker.getBoundingClientRect();
          if (card.left < rail.left) this.picker.scrollLeft += card.left - rail.left - 3;
          else if (card.right > rail.right) this.picker.scrollLeft += card.right - rail.right + 3;
        }
      }
      this.updatePickerControls();
    }
    updatePickerControls() {
      if (!this.picker) return;
      const end = this.picker.scrollWidth - this.picker.clientWidth;
      this.pickerControls.hidden = end <= 1;
      this.pickerPrev.disabled = this.picker.scrollLeft <= 1;
      this.pickerNext.disabled = this.picker.scrollLeft >= end - 1;
    }
    writeUrl() {
      const url = new URL(location.href);
      for (const [key, value, fallback] of [['review_product', this.product, 'all'], ['review_rating', this.rating.value, 'all'], ['review_sort', this.sort.value, 'pictures']]) {
        if (this.fixedProduct && key === 'review_product') { url.searchParams.delete(key); continue; }
        if (value === fallback) url.searchParams.delete(key); else url.searchParams.set(key, value);
      }
      history.pushState({}, '', url);
    }
    reset() { this.product = this.fixedProduct || 'all'; this.rating.value = 'all'; this.limit = this.pageSize; this.syncProductPicker(); this.writeUrl(); this.renderVideos(); this.render(); }
    async get(endpoint, params, signal) {
      const url = new URL(`https://api.judge.me/api/v1/widgets/${endpoint}`);
      url.search = new URLSearchParams({ shop_domain: this.dataset.shop, api_token: this.dataset.token, ...params });
      const timeout = new AbortController(), timer = setTimeout(() => timeout.abort(), 20000);
      const abort = () => timeout.abort(); signal.addEventListener('abort', abort, { once: true });
      try {
        if (signal.aborted) throw new DOMException('Aborted', 'AbortError');
        const response = await fetch(url, { signal: timeout.signal, credentials: 'omit' });
        if (!response.ok) throw Error('Reviews unavailable');
        return await response.json();
      } finally { clearTimeout(timer); signal.removeEventListener('abort', abort); }
    }
    async reviewPage(rating, page, signal, productId = '') {
      const data = await this.get(productId ? 'product_review' : 'all_reviews_page', { json_request: 'true', review_type: 'product-reviews', per_page: '25', ...(rating == null ? {} : { filter_rating: String(rating) }), page: String(page), ...(productId ? { external_id: productId } : {}) }, signal);
      if (!Array.isArray(data.reviews) || (rating != null && data.reviews.some(r => r.rating !== rating)) || (data.reviews.length && Number(data.current_page) !== page)) throw Error('Unexpected review page');
      return data;
    }
    async progressivePage(rating, page, signal, productId = '') {
      const data = await this.reviewPage(rating, page, signal, productId);
      if (!signal.aborted) {
        for (const row of data.reviews) {
          if (row.uuid && !row.is_shop_review && this.matchesScope(row)) this.pendingRows.set(row.uuid, row);
        }
        this.rows = [...this.pendingRows.values()]; this.render();
      }
      return data;
    }
    matchesScope(review) { return !this.fixedProduct || this.reviewHandles.has(productHandle(review)); }
    cacheKey() {
      const ids = [...new Set((this.dataset.productIds || '').split(/\s+/).filter(Boolean))].sort().join(',');
      const handles = [...this.reviewHandles].sort().join(',');
      return `cu-reviews:v2:${this.dataset.shop}:${this.dataset.token}:${this.fixedProduct || 'all'}:${handles}:${ids}`;
    }
    readCache() {
      const key = this.cacheKey(); let snapshot = reviewCache.get(key);
      try { if (!snapshot) snapshot = JSON.parse(sessionStorage.getItem(key)); } catch { /* Storage may be disabled. */ }
      const valid = snapshot && Number.isFinite(snapshot.at) && Date.now() >= snapshot.at && Date.now() - snapshot.at < reviewCacheAge
        && Array.isArray(snapshot.rows) && snapshot.rows.length <= 5000 && snapshot.rows.every(row => row
          && typeof row.uuid === 'string' && Number.isInteger(row.rating) && row.rating >= 1 && row.rating <= 5
          && Array.isArray(row.pictures_urls) && cachedReviewFields.filter(key => !['rating', 'is_anonymous_reviewer', 'verified_buyer', 'product_in_store'].includes(key))
            .every(key => row[key] == null || typeof row[key] === 'string')
          && this.matchesScope(row));
      if (valid) { reviewCache.set(key, snapshot); return snapshot.rows; }
      reviewCache.delete(key);
      try { sessionStorage.removeItem(key); } catch { /* Optional cache. */ }
      return null;
    }
    writeCache() {
      const rows = this.rows.map(row => {
        const cached = Object.fromEntries(cachedReviewFields.map(key => [key, row[key]]));
        cached.pictures_urls = (row.pictures_urls || []).filter(pictureUrl).map(picture => typeof picture === 'string' ? picture
          : Object.fromEntries(['compact', 'huge', 'original', 'url'].map(key => [key, mediaUrl(picture[key])])));
        return cached;
      });
      const snapshot = { at: Date.now(), rows }, key = this.cacheKey();
      const serialized = JSON.stringify(snapshot);
      if (serialized.length > 500000 || rows.length > 5000) return;
      reviewCache.set(key, snapshot);
      try { sessionStorage.setItem(key, serialized); } catch { /* Live loading still works without storage. */ }
    }
    async loadProductReviews(signal) {
      const ids = [...new Set((this.dataset.productIds || '').split(/\s+/).filter(id => /^\d+$/.test(id)))];
      if (!ids.length) throw Error('Product reference unavailable');
      const first = await pool(ids.map(productId => async () => ({ data: await this.progressivePage(null, 1, signal, productId), productId, rating: null })));
      const partitions = [], jobs = [];
      for (const part of first) {
        if (Number(part.data.total_pages) <= 10) partitions.push(part);
        else for (const rating of [5, 4, 3, 2, 1]) jobs.push(async () => ({ data: await this.progressivePage(rating, 1, signal, part.productId), productId: part.productId, rating }));
      }
      partitions.push(...await pool(jobs));
      const remaining = [];
      for (const { data, productId, rating } of partitions) {
        if (Number(data.total_pages) > 10) throw Error('Review partition exceeds the public widget API limit');
        for (let page = 2; page <= Number(data.total_pages); page++) remaining.push(() => this.progressivePage(rating, page, signal, productId));
      }
      const rest = await pool(remaining);
      if (signal.aborted) return;
      this.rows = [...new Map([...partitions.map(p => p.data), ...rest].flatMap(d => d.reviews)
        .filter(r => r.uuid && !r.is_shop_review && this.matchesScope(r)).map(r => [r.uuid, r])).values()];
      this.complete = true; this.writeCache(); this.render();
    }
    async load(force = false) {
      this.request?.abort(); this.request = new AbortController(); const signal = this.request.signal;
      this.complete = false; this.failed = false; this.retry.hidden = true; this.more.hidden = true;
      this.pendingRows = new Map(); this.cardNodes = new Map();
      this.rows = []; this.grid.replaceChildren(); this.grid.setAttribute('aria-busy', 'true');
      this.status.textContent = 'Loading customer reviews…';
      if (!this.dataset.token) { this.failed = true; this.render(); return; }
      const cached = force ? null : this.readCache();
      if (cached) { this.rows = cached; this.complete = true; this.render(); return; }
      try {
        if (this.fixedProduct) { await this.loadProductReviews(signal); return; }
        // The public widget API clamps page numbers to 10 and page size to 25.
        // Start partitions immediately; usable photo cards appear as pages arrive.
        // Complete partitions still drive exact counts, averages and final ordering.
        const first = await pool([5, 4, 3, 2, 1].map(r => async () => ({ data: await this.progressivePage(r, 1, signal), rating: r, productId: '' })));
        const partitions = [], productJobs = [];
        const productIds = [...new Set((this.dataset.productIds || '').split(/\s+/).filter(id => /^\d+$/.test(id)))];
        for (const part of first) {
          if (Number(part.data.total_pages) <= 10) partitions.push(part);
          else {
            if (!productIds.length) throw Error('Product partitions unavailable');
            for (const id of productIds) productJobs.push(async () => ({ data: await this.progressivePage(part.rating, 1, signal, id), rating: part.rating, productId: id }));
          }
        }
        partitions.push(...await pool(productJobs));
        const jobs = [];
        partitions.forEach(({ data, rating, productId }) => {
          if (Number(data.total_pages) > 10) throw Error('Review partition exceeds the public widget API limit');
          for (let page = 2; page <= Number(data.total_pages); page++) jobs.push(() => this.progressivePage(rating, page, signal, productId));
        });
        const rest = await pool(jobs);
        if (signal.aborted) return;
        this.rows = [...new Map([...partitions.map(p => p.data), ...rest].flatMap(d => d.reviews).filter(r => r.uuid && !r.is_shop_review).map(r => [r.uuid, r])).values()];
        this.complete = true; this.writeCache(); this.render();
      } catch {
        if (signal.aborted) return;
        this.request.abort();
        this.failed = true; this.render();
      }
    }
    renderVideos() {
      if (!this.videoTemplate) return;
      const reels = this.videoTemplate.cloneNode(true);
      let count = 0;
      for (const card of reels.querySelectorAll('[data-review-video]')) {
        if (this.product !== 'all' && !card.dataset.products.split(/\s+/).includes(this.product)) card.remove();
        else count++;
      }
      // Reconnecting the player releases warmed clips and rebuilds its observers;
      // its fullscreen playlist therefore contains only the visible product's videos.
      this.videoHost.replaceChildren(reels); this.videoHost.hidden = count === 0;
      this.querySelector('[data-video-empty]').hidden = count > 0;
      this.querySelector('[data-video-count]').textContent = `${count} creator ${count === 1 ? 'video' : 'videos'}`;
    }
    render() {
      this.querySelectorAll('cu-review-filter').forEach(filter => filter.sync());
      const productRows = this.rows.filter(r => this.fixedProduct ? this.matchesScope(r) : this.product === 'all' || productHandle(r) === this.product);
      const rows = productRows.filter(r => this.rating.value === 'all' || r.rating === Number(this.rating.value));
      rows.sort((a, b) => {
        const delta = this.sort.value === 'pictures'
          ? Number((b.pictures_urls || []).some(pictureUrl)) - Number((a.pictures_urls || []).some(pictureUrl))
          : this.sort.value === 'highest' ? b.rating - a.rating : this.sort.value === 'lowest' ? a.rating - b.rating : 0;
        return delta || Date.parse(b.created_at) - Date.parse(a.created_at) || a.uuid.localeCompare(b.uuid);
      });
      // Show usable photos immediately, without flashing text-only reviews ahead
      // of them. Counts/averages and rating-ranked sorts wait for the full set.
      const partial = this.sort.value === 'pictures' ? rows.filter(r => (r.pictures_urls || []).some(pictureUrl))
        : this.sort.value === 'newest' ? rows : [];
      const visible = (this.complete ? rows : partial).slice(0, this.limit);
      const cards = visible.map(review => {
        let cached = this.cardNodes.get(review.uuid);
        if (!cached || cached.review !== review) {
          cached = { review, node: this.card(review) }; this.cardNodes.set(review.uuid, cached);
        }
        return cached.node;
      });
      // Keep existing photo elements and expanded review text as pages arrive.
      // Rebuilding the grid on every response would repeatedly decode images.
      cards.forEach((card, index) => { if (this.grid.children[index] !== card) this.grid.insertBefore(card, this.grid.children[index] || null); });
      for (const card of [...this.grid.children]) if (!cards.includes(card)) card.remove();
      this.grid.setAttribute('aria-busy', String(!this.complete && !this.failed));
      this.querySelector('[data-review-count]').textContent = this.complete ? `${rows.length} ${rows.length === 1 ? 'review' : 'reviews'}` : '';
      this.querySelector('[data-review-empty]').hidden = !this.complete || rows.length > 0;
      this.more.hidden = !this.complete || rows.length <= this.limit;
      this.retry.hidden = !this.failed;
      this.status.textContent = this.failed ? 'We couldn’t load all reviews. Please try again.' : this.complete ? '' : (visible.length ? 'Loading the rest of the reviews…' : 'Loading customer reviews…');
      if (this.fixedProduct) {
        this.querySelector('[data-review-tools]').hidden = this.complete && productRows.length === 0;
        this.querySelector('[data-review-clear]').hidden = productRows.length === 0;
        this.querySelector('[data-review-empty] h3').textContent = productRows.length ? 'No reviews with this rating.' : 'No reviews yet.';
        this.querySelector('[data-review-empty] p').textContent = productRows.length ? 'Try another rating to see more customer reviews.' : this.isBundle ? 'Reviews for the products in this bundle will appear here as they’re published.' : 'Customer reviews for this product will appear here as they’re published.';
        this.renderProductRating(productRows);
      }
      const summary = this.querySelector('[data-review-summary]');
      summary.hidden = !this.complete || productRows.length === 0;
      if (!summary.hidden) {
        const average = productRows.reduce((sum, r) => sum + r.rating, 0) / productRows.length;
        const detail = el('span');
        const stars = el('span', 'cu-reviews__stars', '★★★★★'); stars.setAttribute('aria-hidden', 'true');
        stars.style.setProperty('--review-fill', `${average * 20}%`);
        const countLabel = `${productRows.length} ${this.isBundle ? 'product' : 'customer'} ${productRows.length === 1 ? 'review' : 'reviews'}`;
        detail.append(stars, el('span', '', countLabel));
        summary.replaceChildren(el('strong', '', average.toFixed(2)), detail);
        summary.setAttribute('aria-label', `${average.toFixed(2)} out of 5 from ${countLabel}`);
      }
    }
    renderProductRating(rows) {
      const average = rows.length ? rows.reduce((sum, r) => sum + r.rating, 0) / rows.length : 0;
      for (const link of document.querySelectorAll('[data-product-review-summary]')) {
        if (link.dataset.productReviewSummary !== this.fixedProduct) continue;
        link.replaceChildren();
        link.removeAttribute('aria-label');
        if (!this.complete) { link.textContent = 'Customer reviews'; continue; }
        if (!rows.length) { link.textContent = 'No reviews yet'; continue; }
        const stars = el('span', 'cu-product-review-stars', '★★★★★'); stars.setAttribute('aria-hidden', 'true');
        stars.style.setProperty('--review-fill', `${average * 20}%`);
        link.append(stars, el('span', '', `${average.toFixed(2)} · ${rows.length} ${this.isBundle ? 'product ' : ''}${rows.length === 1 ? 'review' : 'reviews'}`));
        link.setAttribute('aria-label', `${average.toFixed(2)} out of 5 from ${rows.length} ${this.isBundle ? 'product' : 'customer'} ${rows.length === 1 ? 'review' : 'reviews'}${this.isBundle ? ' for the items in this bundle' : ''}. Read reviews.`);
      }
    }
    card(review) {
      const card = el('article', 'cu-review'); card.dataset.reviewId = review.uuid; card.tabIndex = -1;
      const top = el('div', 'cu-review__top');
      const stars = el('span', 'cu-review__stars', '★'.repeat(review.rating) + '☆'.repeat(5 - review.rating));
      stars.setAttribute('aria-label', `${review.rating} out of 5 stars`); stars.setAttribute('role', 'img');
      top.append(stars);
      card.append(top);
      if (review.title?.trim()) card.append(el('h3', '', review.title));
      const body = el('p', 'cu-review__body', review.body || '');
      card.append(body);
      if ((review.body || '').length > 220) {
        body.classList.add('is-collapsed'); body.id = `cu-review-body-${review.uuid}`;
        const expand = el('button', 'cu-review__expand', 'Read more'); expand.type = 'button'; expand.setAttribute('aria-expanded', 'false'); expand.setAttribute('aria-controls', body.id);
        expand.addEventListener('click', () => {
          const collapsed = body.classList.toggle('is-collapsed'); expand.textContent = collapsed ? 'Read more' : 'Show less'; expand.setAttribute('aria-expanded', String(!collapsed));
        }); card.append(expand);
      }
      const photos = el('div', 'cu-review__photos');
      for (const picture of review.pictures_urls || []) {
        const url = pictureUrl(picture);
        if (!url) continue;
        const button = el('button'); button.type = 'button'; button.setAttribute('aria-label', 'Enlarge customer photo');
        const img = el('img'); img.src = mediaUrl(picture.compact) || url; img.alt = 'Customer review photo'; img.loading = 'lazy'; img.width = 80; img.height = 92;
        img.addEventListener('error', () => button.remove(), { once: true }); button.append(img);
        button.addEventListener('click', () => this.openPhoto(url, button)); photos.append(button);
      }
      if (photos.children.length) card.append(photos);
      const author = el('div', 'cu-review__author'); author.append(el('strong', '', review.is_anonymous_reviewer ? 'Anonymous' : review.reviewer_name || 'Customer'));
      if (review.verified_buyer === true || importedVerifiedBuyers.has(review.uuid)) {
        const badge = el('span', 'cu-review__verified', '✓ Verified buyer');
        badge.title = review.verified_buyer === true ? 'Purchase verified by Judge.me.' : 'Purchase verified by ClearUp before importing this review from Loox.';
        author.append(badge);
      }
      card.append(author);
      if (review.reply_content) { const reply = el('div', 'cu-review__reply'); reply.append(el('strong', '', 'ClearUp replied'), document.createTextNode(review.reply_content)); card.append(reply); }
      const handle = productHandle(review);
      const product = el(review.product_in_store && handle ? 'a' : 'span', 'cu-review__product', review.product_title || 'ClearUp');
      if (product.tagName === 'A') product.href = `/products/${encodeURIComponent(handle)}?view=${/kit|duo/.test(handle) ? 'clearup-bundle' : 'clearup-astra'}`;
      card.append(product); return card;
    }
    openPhoto(url, opener) {
      this.photo?.close(); this.photo?.remove();
      const dialog = el('dialog', 'cu-review-photo'); this.photo = dialog; dialog.setAttribute('aria-label', 'Customer review photo');
      const img = el('img'); img.src = url; img.alt = 'Customer review photo';
      const close = el('button'); close.type = 'button'; close.setAttribute('aria-label', 'Close photo');
      close.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="m5 5 14 14M19 5 5 19" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
      close.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
      dialog.addEventListener('close', () => { dialog.remove(); this.photo = null; opener.focus({ preventScroll: true }); }, { once: true });
      dialog.append(img, close); document.body.append(dialog); dialog.showModal();
    }
    disconnectedCallback() { this.events?.abort(); this.request?.abort(); this.pickerObserver?.disconnect(); this.photo?.close(); this.events = null; }
  }
  if (!customElements.get('cu-reviews')) customElements.define('cu-reviews', CuReviews);
})();
